import React from "react";
import { Button } from "react-bootstrap";
import { formatRupees } from "../../../utils/currency";

const TopupCard = ({ pack, isProcessing, onBuy }) => {
  const perListing =
    pack.listingCount > 0
      ? Math.round(pack.priceInPaise / pack.listingCount)
      : null;

  return (
    <div
      className={[
        "billing-topup-card",
        pack.isBestValue ? "is-highlight" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {pack.isBestValue && (
        <span className="billing-topup-badge">Best value</span>
      )}

      <div className="billing-topup-count">
        <span className="billing-topup-count-num">{pack.listingCount}</span>
        <span className="billing-topup-count-unit">
          credit{pack.listingCount === 1 ? "" : "s"}
        </span>
      </div>

      <div className="billing-topup-price">
        {formatRupees(pack.priceInPaise)}
      </div>

      {perListing != null && (
        <div className="billing-topup-per">
          {formatRupees(perListing)} / credit
        </div>
      )}

      <Button
        className="billing-topup-cta"
        disabled={isProcessing}
        onClick={() => onBuy(pack)}
      >
        {isProcessing ? "Opening..." : "Buy credits"}
      </Button>
    </div>
  );
};

export default TopupCard;
